<div class="overflow-auto border rounded-large ms-medium-t" [ngStyle]="{ height: height ?? 'auto' }">
  <table class="fill">
    <caption class="is-vishidden">
      {{
        captionTranslationKey | finLocalization
      }}
    </caption>
    <thead>
      <tr class="bold-type font-body-2">
        <th class="align-left ps-small-x ps-medium-y border-bottom total-column white-bg top sticky opaque z1">
          {{ xColumn.translationKey | finLocalization }}
        </th>
        <th class="align-right ps-small-x ps-medium-y border-bottom total-column white-bg top sticky opaque z1">
          {{ 'CORPORATE.corporatePortal.data.filter.' + currentDateFilter | finLocalization }}
        </th>
        <th class="align-right ps-small-x ps-medium-y border-bottom total-column white-bg top sticky opaque z1"></th>
        <th class="align-right ps-small-x ps-medium-y border-bottom total-column white-bg top sticky opaque z1"></th>
        <th class="filler border-bottom white-bg top sticky opaque z1"></th>
      </tr>
    </thead>
    <tbody class="font-body-1">
      <tr *ngFor="let row of rows; let last = last">
        <td class="align-left ps-small-x ps-medium-y total-column" [ngClass]="{ 'border-bottom': !last }">
          {{
            xColumn.type === XColumnType.DATE
              ? (toISOStringPreserveTimeZone(row.xValue) | finDateFormat: 'MONTH_SHORT')
              : row.xValue
          }}
        </td>
        <td class="align-right bold-type ps-small-x ps-medium-y total-column" [ngClass]="{ 'border-bottom': !last }">
          {{ row.value | number: '1.0-0' }}
        </td>
        <td
          class="align-right bold-type ps-small-x ps-medium-y total-column"
          [ngClass]="{ 'border-bottom': !last }"
        ></td>
        <td
          class="align-right bold-type ps-small-x ps-medium-y total-column"
          [ngClass]="{ 'border-bottom': !last }"
        ></td>
        <td class="filler-column" [ngClass]="{ 'border-bottom': !last }"></td>
      </tr>
    </tbody>
  </table>
</div>
